export default __webpack_public_path__ + "static/media/img-0152-india-half-face.f7a953fd.png";